import {
	createBrowserRouter,
	Navigate,
	RouterProvider
} from 'react-router-dom';
import { lazy, Suspense } from 'react';

import { App, AppAuthProvider } from '.';
import { RequireRole } from '../auth/RequireRole';

const AdminApp = lazy(() => import('./admin-app'));
const DataManagerApp = lazy(() => import('./data-manager-app'));
const SettingsApp = lazy(() => import('./settings-app'));
const EstimateViewerPage = lazy(() => import('../pages/estimate-viewer-page'));

export const AppRouter = () => {
    const cadElement = <AppAuthProvider><App/></AppAuthProvider>;
    const adminElement = (
        <AppAuthProvider>
            <RequireRole required={['blueprint:super_admin', 'blueprint:admin']}>
                <Suspense fallback={null}>
                    <AdminApp/>
                </Suspense>
            </RequireRole>
        </AppAuthProvider>
    );
    const settingsElement = (
        <AppAuthProvider>
            <RequireRole required={['blueprint:super_admin', 'blueprint:admin']}>
                <Suspense fallback={null}>
                    <SettingsApp/>
                </Suspense>
            </RequireRole>
        </AppAuthProvider>
    );
	const productsElement = (
        <AppAuthProvider>
            <RequireRole required={['blueprint:super_admin', 'blueprint:admin', 'blueprint:srblueprint']}>
                <Suspense fallback={null}>
                    <DataManagerApp/>
                </Suspense>
            </RequireRole>
        </AppAuthProvider>
    );
	const estimateViewerElement = (
        <Suspense fallback={<div>Loading...</div>}>
            <EstimateViewerPage />
        </Suspense>
    );
    const router = createBrowserRouter([
        // Keystone OAuth callback
        { path: '/auth/callback', element: <AppAuthProvider><App/></AppAuthProvider> },
        // Public estimate viewer
        { path: '/estimate/view', element: estimateViewerElement },
        // CAD routes — optional params keep cadElement mounted across Find Customer navigation
        { path: '/r/:email?/:designId?/:version?', element: cadElement },
        { path: '/v/:email/:designId/:version', element: cadElement },
        { path: '/v/:designHash', element: cadElement },
        { path: '/', element: cadElement },
        // Admin/Settings routes
        { path: '/admin', element: adminElement },
        { path: '/admin/products', element: productsElement },
        { path: '/settings', element: settingsElement },
        // Fallback
        { path: '*', element: <Navigate to="/r"/> }
    ], {
        future: {
            // eslint-disable-next-line camelcase
            // v7_normalizeFormMethod: true
        }
    });

    // console.log('render:AppRouter');
    return <RouterProvider router={router}/>;
};
